import qsStringify from "./qsStringify";
import api from "./api";

export const getGalleries = (locale, queries) => {
  const query = qsStringify({
    locale,
    populate: [
      "images",
      "page_info.seo_info",
      "page_info.seo_info.image",
      "page_info.banner",
    ],
    sort: ["createdAt:asc"],
    ...queries,
  });
  return api.get(`/galleries?${query}`).then(res => res.data);
};
